/* eslint-disable react/prop-types */

import React, { forwardRef } from 'react';
import { Triangle, Rectangle } from './Shapes';

// eslint-disable-next-line react/prop-types, react/display-name
const TransformableShape = forwardRef((props, ref) => {
  if (props.type === 'rectangle') {
    return (
        <Rectangle
            {...props}
            ref={ref}
        />
    );
  } else if (props.type === 'triangleLeft' || props.type === 'triangleRight') {
    return (
        <Triangle
        {...props}
          ref={ref}
          type={props.type}
        />
    );
  } else throw new Error('Invalid shape type');
});
export default React.memo(TransformableShape);
